// extracted by mini-css-extract-plugin
module.exports = {"table":"Lot_table__3n1uD"};